/**
* 将树状数组数据转扁平数组数据
* @param {any} treeArr 树状结构数组数据源
* @param {string} idField id字段名称
* @param {string} pidField parent id字段名称
* @param {string} childrenField 子节点字段名称
* @param {object} [rootPidVal=null] 根节点id值。当根节点id值缺失时可以自定义其值,缺失时默认值为null
* @param {string} [sortField=''] -排序字段名称,默认空不排序
* @param {boolean} [isAsc=true] -排序方式,默认true为asc升序
* @returns {array} 返回扁平结构数组
*/
export const getListArr = (treeArr, idField, pidField, childrenField, rootPidVal = null, sortField = '', isAsc = true) => {
    //克隆数据副本
    let data = JSON.parse(JSON.stringify(treeArr));
    let arr = [];
    const toList = (data, arr, pid) => {
        for (let i = 0; i < data.length; i++) {
            let obj = JSON.parse(JSON.stringify(data[i]));
            obj[pidField] = pidField in data[i] ? data[i][pidField] : pid;
            //删除子节点数组属性
            if (childrenField in obj) delete obj[childrenField];
            arr.push(obj);
            //对有子节点数组属性的节点递归
            if (childrenField in data[i]) toList(data[i][childrenField], arr, data[i][idField]);
        }
    }
    //默认根节点ID为null
    toList(data, arr, rootPidVal);
    //排序
    if (sortField) {
        let n = isAsc ? 1 : -1;
        arr.sort((a, b) => {
            return a[sortField] > b[sortField] ? 1 * n : (a[sortField] < b[sortField] ? -1 * n : 0 * n);
        })
    }
    return arr;
};

/**
* 将扁平结构数组数据转树状结构数组
* @param {array} listArr list扁平结构数组源数据
* @param {string} idField id字段名称
* @param {string} pidField parent id字段名称
* @param {string} childrenField 子节点字段名称
* @param {string} [sortField=''] -排序字段名称,默认空不排序
* @param {boolean} [isAsc=true] -排序方式,默认true为asc升序
* @returns {array} 返回树状结构数组
*/
export const getTreeArr = (listArr, idField, pidField, childrenField, sortField = '', isAsc = true) => {
    //克隆数据副本
    let data = JSON.parse(JSON.stringify(listArr));
    //转为树状结构数组
    data = data.filter(father => {
        let childArr = data.filter(child => father[idField] == child[pidField]);
        childArr.length > 0 ? father[childrenField] = childArr : '';
        return data.every(m => m[idField] != father[pidField])
    });
    //树状数组排序
    if (sortField) {
        let n = isAsc ? 1 : -1;
        data = sortTree(data);
        function sortTree(source) {
            for (let i = 0; i < source.length; i++) {
                if (source[i][childrenField])
                    sortTree(source[i][childrenField])
            }
            return source.sort((a, b) => {
                return a[sortField] > b[sortField] ? 1 * n : (a[sortField] < b[sortField] ? -1 * n : 0 * n)
            })
        }
    }
    return data
};